
import { supabase } from "@/integrations/supabase/client";

/**
 * Debug utility to log the current auth state
 */
export const logAuthState = async () => {
  try {
    console.group("Auth State Debug");
    
    // Get current session
    const { data: sessionData } = await supabase.auth.getSession();
    console.log("Current session:", sessionData.session);
    
    // Check localStorage
    const storageKey = 'testera_auth_token';
    const storedSession = localStorage.getItem(storageKey);
    console.log(`Local storage (${storageKey}):`, storedSession ? 'exists' : 'missing');
    
    // Check for code verifier (PKCE auth)
    const codeVerifierKey = `${storageKey}-code-verifier`;
    const codeVerifier = localStorage.getItem(codeVerifierKey);
    console.log(`Code verifier (${codeVerifierKey}):`, codeVerifier ? 'exists' : 'missing');
    
    if (sessionData.session?.user) {
      console.log("User ID:", sessionData.session.user.id);
      console.log("User email:", sessionData.session.user.email);
      console.log("Auth provider:", sessionData.session.user.app_metadata?.provider || 'email');
      console.log("Email confirmed:", !!sessionData.session.user.email_confirmed_at);
      console.log("User metadata:", sessionData.session.user.user_metadata);
      console.log("App metadata:", sessionData.session.user.app_metadata);
      
      // Check profile
      const { data: profileData, error: profileError } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', sessionData.session.user.id)
        .single();
        
      if (profileError) {
        console.error("Error fetching profile:", profileError);
      } else {
        console.log("User profile:", profileData);
      }
    } else {
      console.log("No authenticated user found");
      
      // Check URL for auth fragments
      const url = new URL(window.location.href);
      const hasAuthParams = url.hash.includes('access_token') || 
                           url.searchParams.has('code') || 
                           url.searchParams.has('error');
      
      console.log("URL contains auth params:", hasAuthParams);
      if (hasAuthParams) {
        console.log("Current URL:", window.location.href);
      }
    }
    
    console.groupEnd();
  } catch (error) {
    console.error("Error in logAuthState:", error);
  }
};

// Expose debug function globally
(window as any).debugAuth = logAuthState;

/**
 * Debug utility to check for authentication race conditions
 */
export const checkAuthRaceConditions = () => {
  const hasStoredSession = localStorage.getItem('testera_auth_token') !== null;
  const hasCodeVerifier = localStorage.getItem('testera_auth_token-code-verifier') !== null;
  
  console.group("Auth Race Condition Check");
  console.log("Has stored session:", hasStoredSession);
  console.log("Has code verifier:", hasCodeVerifier);
  
  // Check URL for auth parameters
  const url = new URL(window.location.href);
  const hasAuthCode = url.searchParams.has('code');
  const hasAuthError = url.searchParams.has('error');
  const hasAuthToken = url.hash.includes('access_token');
  
  console.log("URL has auth code:", hasAuthCode);
  console.log("URL has auth error:", hasAuthError);
  console.log("URL has auth token:", hasAuthToken);
  
  if (hasAuthCode || hasAuthError || hasAuthToken) {
    console.log("Auth parameters detected in URL");
    console.log("Current URL:", window.location.href);
  }
  
  console.groupEnd();
};

// Expose debug function globally
(window as any).checkAuthRaceConditions = checkAuthRaceConditions;
